import React from "react";

/**
 * Editable list with add (+) and remove per row — editor only (hidden in PDF).
 */
export default function EditableListEditor({
  label,
  items,
  onChange,
  placeholder = "Enter item...",
  addLabel = "Add item",
}) {
  const updateItem = (index, value) => {
    const next = [...items];
    next[index] = value;
    onChange(next);
  };

  const removeItem = (index) => {
    if (items.length <= 1) return;
    onChange(items.filter((_, i) => i !== index));
  };

  const addItem = () => {
    onChange([...items, ""]);
  };

  return (
    <div className="mpi-editable-list">
      {label ? <strong className="d-block mb-2">{label}</strong> : null}
      {items.map((item, index) => (
        <div key={index} className="mpi-editable-list-row mpi-editor-only-row">
          <textarea
            className="form-control form-control-sm"
            rows={2}
            value={item}
            placeholder={placeholder}
            onChange={(e) => updateItem(index, e.target.value)}
          />
          <button
            type="button"
            className="btn btn-sm btn-outline-danger mpi-list-remove-btn"
            title="Remove"
            disabled={items.length <= 1}
            onClick={() => removeItem(index)}
          >
            <i className="bi bi-x-lg" />
          </button>
        </div>
      ))}
      <button
        type="button"
        className="btn btn-sm btn-outline-primary mpi-editor-only mt-1"
        onClick={addItem}
      >
        <i className="bi bi-plus-lg me-1" />
        {addLabel}
      </button>
    </div>
  );
}
